import { useState, useEffect } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import Flatpickr from "react-flatpickr"
import { Check, X, Trash} from "react-feather"

const AsesoriaResponsabilidadCivilConstruccionExtraForm = (props) => {
    
  function validationSchema() {
    return yup.object({})
  }

  const formik = useFormik({
    initialValues: props.data,
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {}
  })
  const [open, setOpen] = useState('')

  const toggle = id => {
    open === id ? setOpen() : setOpen(id)
  }

  useEffect(() => {
    props.form.setFieldValue(`seguroAnual['subcontratistasEmpleados'][${props.index}].asesoria`, formik.values)
  }, [formik.values])
  
  return (
    <div className="col-12 mt-1 mb-1">
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      
    <Accordion className='accordion-border col-12' open={open} toggle={toggle}>
      <AccordionItem>
        <AccordionHeader targetId='1'>Responsabilidad civil de construcción del subcontratista</AccordionHeader>
        <AccordionBody accordionId='1'>
          {/* Sección del Seguro Anual */}
          <div className="col-12 d-flex flex-wrap mt-2">
            <h3 className="col-12  fw-bolder">Seguro Anual</h3>
            <h5 className="col-12 mb-2">Indique los ramos de construcción que ha trabajado durante los últimos tres años:</h5>
            {/* tipoServicios array */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Reparaciones que afecten elementos estructurales :
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`reparacionesAfectenStructurales-${props.index}` } 
                    id={`reparacionesAfectenStructurales-${props.index}` }
                    checked={formik.values?.reparacionesAfectenStructurales}
                    onChange={(e) => {
                      formik.setFieldValue("reparacionesAfectenStructurales", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`reparacionesAfectenStructurales-${props.index}` } >
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* tipoServicios array */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' for="apuntalamientos" >
                Apuntalamientos:
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`apuntalamientos-${props.index}` } 
                    id={`apuntalamientos-${props.index}` }
                    checked={formik.values?.apuntalamientos}
                    onChange={(e) => {
                      formik.setFieldValue("apuntalamientos", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`apuntalamientos-${props.index}` }  >
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* tipoServicios array */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Demoliciones :
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`demoliciones-${props.index}` } 
                    id={`demoliciones-${props.index}` }
                    checked={formik.values?.demoliciones}
                    onChange={(e) => {
                      formik.setFieldValue("demoliciones", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`demoliciones-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* tipoServicios array */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Obras con empleos de explosivos :
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`obrasEmpleosExplosivos-${props.index}` } 
                    id={`obrasEmpleosExplosivos-${props.index}` }
                    checked={formik.values?.obrasEmpleosExplosivos}
                    onChange={(e) => {
                      formik.setFieldValue("obrasEmpleosExplosivos", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`obrasEmpleosExplosivos-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* Pilotajes */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Pilotajes:
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`pilotajes-${props.index}` } 
                    id={`pilotajes-${props.index}` }
                    checked={formik.values?.pilotajes}
                    onChange={(e) => {
                      formik.setFieldValue("pilotajes", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`pilotajes-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* Cimentación */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                Cimentación :
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`cimentacion-${props.index}` } 
                    id={`cimentacion-${props.index}` }
                    checked={formik.values?.cimentacion}
                    onChange={(e) => {
                      formik.setFieldValue("cimentacion", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`cimentacion-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* Excavación */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Excavación:
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`excavacion-${props.index}` } 
                    id={`excavacion-${props.index}` }
                    checked={formik.values?.excavacion}
                    onChange={(e) => {
                      formik.setFieldValue("excavacion", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`excavacion-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* Techados */}
            <div className="col-12 col-md-6 w-input d-flex ">
              <div className=" ww-50A mmr-1">
                <Label className='form-label fw-bolder align-middle ' >
                  Techados :
                </Label>
              </div>
              <div className="ww-50">
                <div className='form-switch '>
                  <Input 
                    type='switch' 
                    name={`techados-${props.index}` } 
                    id={`techados-${props.index}` }
                    checked={formik.values?.techados}
                    onChange={(e) => {
                      formik.setFieldValue("techados", e.target.checked)
                    }}
                  />
                  <Label className='form-check-label' for={`techados-${props.index}` }>
                    <span className='switch-icon-left'>
                      <Check size={14} />
                    </span>
                    <span className='switch-icon-right'>
                      <X size={14} />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            {/* Otros */}
            <div className="col-12 col-lg-6 mb-1 w-input">
              <Label className="form-label fw-bolder" >
                Otros (Descríbalos) 
              </Label>
              <Input
                placeholder=""
                value={formik.values?.otrosDescribalos}
                invalid={formik.errors.otrosDescribalos && true}
                onChange={(e) => {
                  formik.setFieldValue("otrosDescribalos", e.target.value)
                }}
              />
              {formik.errors.otrosDescribalos && (
                <FormFeedback>{formik.errors.otrosDescribalos}</FormFeedback>
              )}
            </div>
            {/* Otros */}
            <div className="col-12 col-lg-6 mb-1 w-input">
              <Label className="form-label fw-bolder" >
                Indique si estima que en el futuro realice Obras distintas a las que ha efectuado. Señale cuáles 
              </Label>
              <Input
                placeholder=""
                value={formik.values?.obrasDistintas}
                invalid={formik.errors.obrasDistintas && true}
                onChange={(e) => {
                  formik.setFieldValue("obrasDistintas", e.target.value)
                }}
              />
              {formik.errors.obrasDistintas && (
                <FormFeedback>{formik.errors.obrasDistintas}</FormFeedback>
              )}
            </div>
            {/* participa en Consorcio */}
            <div className="col-12 col-lg-6 mb-1 w-input">
              <Label className="form-label fw-bolder" >
                Indique si participa en Consorcio de Construcción
              </Label>
              <Input
                placeholder=""
                value={formik.values?.participaConsorcioConstruccion}
                invalid={formik.errors.participaConsorcioConstruccion && true}
                onChange={(e) => {
                  formik.setFieldValue("participaConsorcioConstruccion", e.target.value)
                }}
              />
              {formik.errors.participaConsorcioConstruccion && (
                <FormFeedback>{formik.errors.participaConsorcioConstruccion}</FormFeedback>
              )}
            </div>
            {/* Valor de los contratos */}
            <div className="col-12 col-lg-6 mb-1 w-input d-flex flex-wrap">
              <Label className="form-label fw-bolder" >
              Indique volumen anual de Obras (Valor de los contratos) durante año anterior y estimación para el año en curso
              </Label>
              <div className="col-6 w-input">
              <Label className="form-label fw-bolder" >
                Durante año anterior
              </Label>
                <Input
                  placeholder=""
                  value={formik.values?.volumenAnualObrasAnoAnterior}
                  invalid={formik.errors.volumenAnualObrasAnoAnterior && true}
                  onChange={(e) => {
                    formik.setFieldValue("volumenAnualObrasAnoAnterior", e.target.value)
                  }}
                />
                {formik.errors.volumenAnualObrasAnoAnterior && (
                  <FormFeedback>{formik.errors.volumenAnualObrasAnoAnterior}</FormFeedback>
                )}
              </div>
              <div className="col-6 w-input">
                <Label className="form-label fw-bolder" >
                  Estimación para el año en curso
                </Label>
                <Input
                  placeholder=""
                  value={formik.values?.volumenAnualObrasAnoCurso}
                  invalid={formik.errors.volumenAnualObrasAnoCurso && true}
                  onChange={(e) => {
                    formik.setFieldValue("volumenAnualObrasAnoCurso", e.target.value)
                  }}
                />
                {formik.errors.volumenAnualObrasAnoCurso && (
                  <FormFeedback>{formik.errors.volumenAnualObrasAnoCurso}</FormFeedback>
                )}
              </div>
            </div>
          </div>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
    </div>
  )
}

export default AsesoriaResponsabilidadCivilConstruccionExtraForm
